import { createContext, useState } from "react";
import { getArticles, updateArticlesPositionsService } from "../services/articlesServices";
import toast from "react-hot-toast";
import { extractIdAndPosition } from "../helpers/functions";

const ArticleSliderContext = createContext();

const ArticleSliderProvider = ({ children }) => {
  const [articles, setArticles] = useState([]);

  const getAllArticles = async () => {
    try {
      const { data } = await getArticles();
      setArticles(data?.allArticles);
    } catch (error) {
      toast.error('Error al obtener los articulos');
    }
  };

  const updateArticlesPositions = async () => {
    try {
      const idAndPosition = extractIdAndPosition(articles);
      const { data } = await updateArticlesPositionsService(idAndPosition);
      toast.success(data?.message);
    } catch (error) {
      toast.error('Error al actualizar las posiciones');
    }
  }

  return (
    <ArticleSliderContext.Provider
      value={{
        getAllArticles,
        articles,
        setArticles,
        updateArticlesPositions
      }}
    >
      {children}
    </ArticleSliderContext.Provider>
  );
};

export { ArticleSliderProvider };

export default ArticleSliderContext;